import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Button, 
  useTheme 
} from '@mui/material';
import { tokens } from "../../../theme";

const ClearHistoryModal = ({ open, onClose, onConfirm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="clear-history-dialog-title"
      aria-describedby="clear-history-dialog-description"
      PaperProps={{
        sx: {
          backgroundColor: 'var(--fx-paper)',
          backgroundImage: 'none',
          maxWidth: '400px'
        }
      }}
    >
      <DialogTitle id="clear-history-dialog-title" sx={{ color: colors.grey[100] }}>
        Clear Training History?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="clear-history-dialog-description" sx={{ color: colors.grey[300] }}>
          Are you sure you want to delete ALL training history? This action cannot be undone and you will lose all recorded metrics and run data.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button 
          onClick={onClose} 
          sx={{ color: colors.grey[100] }}
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="error" 
          autoFocus
          sx={{
            backgroundColor: colors.redAccent?.[500] || '#f44336',
            '&:hover': {
              backgroundColor: colors.redAccent?.[500] || '#ed291bff',
            }
          }}
        >
          Clear History
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClearHistoryModal;
